import {AbstractDrawLinestring} from "../abstract-draw-linestring";

export class EditorDrawLinestring extends AbstractDrawLinestring {

}
